import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Administración" },
  { label: "Calificadora Clientes", icon: "fas fa-exclamation-circle", color: "#10b981", bg: "#f0fdf4", href: "/CalificadoraClientes", desc: "Calificación de clientes", perm: "edoCtaClientes" },
  { label: "Abonos", icon: "fas fa-dollar-sign", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoAbonos", desc: "Abonos recibidos", perm: "abonos" },
];

function BotonesReportesAdmin() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-dollar-sign" color="#6366f1" bg="#eef2ff" title="Reportes Admin" subtitle="Reportes administrativos y de cobranza" />
        <div className="row">
          {ITEMS.map((r, i) =>
            r.type === "section"
              ? <MenuSection key={i} title={r.label} />
              : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
          )}
        </div>
      </div>
    </>
  );
}

export default BotonesReportesAdmin;
